<mat-menu #childMenu="matMenu">

  @for (child of menuObject; track child) {
    <span>
      @if (child?.rights?.view) {
        <!-- Handle branch node menu items -->
        @if (child.children && child.children.length > 0) {
          <span>
            <button (click)="onItemClick(child, childMenu)" mat-menu-item color="primary" [matMenuTriggerFor]="menu.childMenu">
              <!--<mat-icon>{{child.icon}}</mat-icon>-->
              <span>{{child.name}}</span>
            </button>
            <app-menu-item #menu [menuObject]="child.children"></app-menu-item>
          </span>
        }
        <!-- Handle leaf node menu items -->
        @if (!child.children || child.children.length === 0) {
          <span>
            <button mat-menu-item (click)="onItemClick(child, childMenu)">
              <!--<mat-icon>{{child.icon}}</mat-icon>-->
              <span>{{child.name}}</span>
            </button>
          </span>
        }
      }
    </span>
  }
</mat-menu>
